import { useTheme } from 'contexts'
import React from 'react'

import { ProgressIndicator } from 'partials/PostPlayer/widgets/ProgressIndicator'

import { Box } from 'widgets/Box'

import { Post } from 'types/post'

type Props = {
  post?: Post
  currentStep: number
  totalSteps: number
  progress: number
}

export const StepsPaginator = ({ post, currentStep, totalSteps, progress }: Props) => {
  const theme = useTheme()

  const getRenderItem = (index: number) => {
    const step = post?.steps[currentStep - 1]
    const isVideo = step?.file?.mimeType.includes('video')
    const color = index < currentStep ? 'v2primary' : 'greyLight'
    const width = `${100 / totalSteps - totalSteps / (theme.spacing.xs * 2)}%`

    if (!isVideo || index !== currentStep - 1) {
      return <Box key={index} height={2} width={width} margin='xs' backgroundColor={color} />
    }

    return (
      <Box key={index} height={2} width={width} margin='xs'>
        <ProgressIndicator value={progress} />
      </Box>
    )
  }

  return (
    <Box flexDirection='row' padding='smd' align='center' justifyContent='center'>
      {[...Array(totalSteps).keys()].map((index) => {
        return getRenderItem(index)
      })}
    </Box>
  )
}
